import TYPES from './types'

export default {
  [TYPES.SPINNER.SHOW]: ({ commit }, text) => {
    commit(TYPES.SPINNER.SHOW, text)
  },
  [TYPES.SPINNER.HIDE]: ({ commit }) => {
    commit(TYPES.SPINNER.HIDE)
  }
}
